<div class="panel fixed-height-panel">
    <div class="panel-header">
        <h1>Remove <h1>{{type==='place'?'Place':'Event'}}</h1> Geolocation / Source</h1>
    </div>
    <ig-list>
        <div header>
            <ig-list-column-header>
                GEO-LOCATION (GPS/ADDRESS)
            </ig-list-column-header>
        </div>
        <div body>
            <ig-spinner *ngIf="isLoadingFeeds"></ig-spinner>
            <ng-container *ngIf="!isLoadingFeeds">
                <ig-list-item *ngFor="let location of hubLocations">
                    <div style="flex: 4">
                        {{location.title || location.id}} -
                        {{location.socialName=='eventful'?'Performers,Venues, Ticketing Websites':location.socialName}}
                        - {{location.radius/1609}} miles
                    </div>
                    <ig-row-action-buttons style="flex: 1">
                        <mat-icon matTooltip="Edit" (click)="editLocationFeed(location)">
                            edit
                        </mat-icon>
                        <mat-icon matTooltip="Delete" (click)="deleteLocationFeed(location)">
                            clear
                        </mat-icon>
                    </ig-row-action-buttons>
                </ig-list-item>
                <div *ngIf="!hubLocations||!hubLocations.length" class="empty-list">
                    No Content Here...
                </div>
            </ng-container>
        </div>
    </ig-list>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.account/content.management/location.feed.list/location.feed.list.component.html